import { BgColorType, SpacingType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  bgColor?: BgColorType;
  className?: HTMLAttributes<HTMLElement>["className"];
  id?: HTMLAttributes<HTMLElement>["id"];
  gap?: SpacingType;
  align?: CSSProperties["alignItems"];
  justify?: CSSProperties["justifyContent"];
  padding?: SpacingType;
  vPadding?: SpacingType;
  hPadding?: SpacingType;
  width?: CSSProperties["width"];
}>;

export default function Section({
  bgColor,
  children,
  className,
  id,
  gap,
  align,
  justify,
  padding,
  vPadding,
  hPadding,
  width,
}: Props) {
  if (!gap) {
    gap = "3xl";
  }

  const styles: CSSProperties = {
    overflow: "hidden",
    backgroundColor: bgColor ? `var(--color-background-${bgColor})` : undefined,
    borderRadius: "var(--border-radius-md)",

    display: "flex",
    flexDirection: "column",
    gap: `var(--spacing-${gap})`,

    ...(align && { alignItems: align }),
    ...(justify && { justifyContent: justify }),

    ...(padding && { padding: `var(--spacing-${padding})` }),
    ...(hPadding && { paddingInline: `var(--spacing-${hPadding})` }),
    ...(vPadding && { paddingBlock: `var(--spacing-${vPadding})` }),

    width: width || "100%",
  };

  return (
    <section className={className} id={id} style={styles}>
      {children}
    </section>
  );
}
